import { SpSadtGuideStruct } from "../../structs/private-billing/sp-sadt-guide.struct";

export class SpSadtGuideRequest {
    public spSadtGuideStruct: SpSadtGuideStruct;
}